import { render, staticRenderFns } from "./ProgramCardArray.vue?vue&type=template&id=c566f214&"
import script from "./ProgramCardArray.vue?vue&type=script&lang=js&"
export * from "./ProgramCardArray.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCardArray.vue?vue&type=style&index=0&id=c566f214&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports